import { RegistrationFlow } from '@/components/registration/registration-flow';

export default function RegisterPage() {
  return <RegistrationFlow />;
}
